import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { TEMPLATES } from "./constants.js";

export function TemplateSelector({ selectedTemplate, onSelect }) {
  const { t } = useLanguage();

  return (
    <div className="bg-white dark:bg-slate-800/60 backdrop-blur rounded-xl border border-ink-900/10 dark:border-white/10 p-5">
      <label className="block text-sm font-medium text-ink-700 dark:text-white/90 mb-2">
        {t("posterTemplate")}
      </label>
      <div className="grid grid-cols-2 gap-2">
        {TEMPLATES.map((tm) => (
          <button
            key={tm.id}
            type="button"
            onClick={() => onSelect(tm.id)}
            className={`relative h-12 rounded-lg overflow-hidden transition-all ${
              selectedTemplate === tm.id
                ? "ring-2 ring-orange-400 ring-offset-2 ring-offset-slate-900"
                : "hover:opacity-90"
            }`}
            style={{ background: tm.bg }}
          >
            <span className="relative z-10 text-white text-xs font-semibold px-2">
              {t(tm.nameKey)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
